// Gallery entry — sits in the explore-gallery header. Lets the user swap
// from passive browsing ("what blocks exist?") to guided discovery
// ("show me alternatives to what I'm looking at"). Minimal-stub onApply
// toasts the picked headline; Workstream D ships the real workspace
// insertion hook (projectSlice.addBlock).

import { useStudioLocale } from '@/i18n'
import { BrainstormCta } from './brainstorm-cta'

export function GalleryBrainstormCta({ pattern, dsId }: { pattern?: string; dsId?: string }) {
  // `BrainstormCta` documents that "Callers pass their locale-appropriate
  // copy" — this is the caller, so this is where the locale is read.
  const copy = useStudioLocale().strings.starters.gallery
  return (
    <BrainstormCta
      entry="gallery"
      label={copy.findSimilarBlocks}
      pattern={pattern}
      dsId={dsId}
    />
  )
}
